/* eslint-disable react/prop-types */
import SubNav from "components/SubNav";
import { getCategoryHref } from "lib/helpers";

const CategoriesNav = ({ categories, parentLinks }) => {
  const items = [];

  parentLinks.map((parentLink) => {
    items.push(parentLink);
  });

  categories.map((category) =>
    items.push({
      href: getCategoryHref(category),
      label: category.title,
    })
  );

  return <SubNav items={items} />;
};

export default CategoriesNav;
